import React from 'react';

// Seat status constants (no external dependency)
var SEAT_STATUS = {
  AVAILABLE: 'available',
  TAKEN: 'taken',
  TEMPORARY_TAKEN: 'temporary_taken',
  SELECTED: 'selected',
  FIRST_COME_FIRST_SERVE: 'first_come_first_serve'
};

class Seat extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    var seatId = this.props.seatId;
    var status = this.props.status;
    var disabled = this.props.disabled;
    var onClick = this.props.onClick;

    if (disabled || status === SEAT_STATUS.TAKEN || status === SEAT_STATUS.TEMPORARY_TAKEN || status === SEAT_STATUS.FIRST_COME_FIRST_SERVE) {
      return;
    }

    if (onClick) {
      onClick(seatId);
    }
  }

  render() {
    var seatId = this.props.seatId;
    var status = this.props.status;
    var price = this.props.price;
    var label = this.props.label;
    var disabled = this.props.disabled;
    var pending = this.props.pending;
    var pendingRelease = this.props.pendingRelease;

    var isFCFS = status === SEAT_STATUS.FIRST_COME_FIRST_SERVE;
    var isClickable = !pending && !pendingRelease && !disabled &&
      status !== SEAT_STATUS.TAKEN &&
      status !== SEAT_STATUS.TEMPORARY_TAKEN &&
      !isFCFS;

    var classNames = ['seat', status];
    if (pending || pendingRelease) classNames.push('pending');
    if (disabled) classNames.push('disabled');
    if (isClickable) classNames.push('clickable');

    if (pendingRelease) {
      return (
        <div
          className={classNames.join(' ')}
          title={'Releasing seat ' + seatId}
        >
          <span className="seat-pending-text">releasing</span>
          <span className="seat-pending-text">seat</span>
        </div>
      );
    }

    if (pending) {
      return (
        <div
          className={classNames.join(' ')}
          title={'Checking availability for seat ' + seatId}
        >
          <span className="seat-pending-text">checking</span>
          <span className="seat-pending-text">availability</span>
        </div>
      );
    }

    var displayLabel;
    var titleText;
    if (isFCFS) {
      displayLabel = '\u2715';
      titleText = 'Seat ' + seatId + ' - First come first serve';
    } else if (label != null) {
      displayLabel = label;
      titleText = 'Seat ' + seatId;
    } else {
      displayLabel = price > 0 ? '+$' + price : '$0';
      titleText = 'Seat ' + seatId + (price > 0 ? ' - +$' + price + ' add-on' : '');
    }

    return (
      <div
        className={classNames.join(' ')}
        onClick={this.handleClick}
        title={titleText}
      >
        <span className="seat-price">{displayLabel}</span>
      </div>
    );
  }
}

export default Seat;
